import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { documentTitleLabelKey, formatDocumentTitle } from "./document-title.js";

export function useDocumentTitle(): void {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const labelKey = documentTitleLabelKey(pathname);
  const title = formatDocumentTitle(labelKey ? t(labelKey) : null, t("app.name"));

  useEffect(() => {
    document.title = title;
  }, [title]);
}
